<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>备用金账单明细使用说明:<br>
					<span>3、查询关键字:单号、申请人。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			
		</pre-base>
	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "petty_cash_listD",
					"title": "备用金使用账单明细",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"isShowEdit": "0",
					"sel_action": 'exp_dtys_byj_listD',
					"upd_action": '',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
						"name": "申请人",
						"val": "",
						"key": "u_name",
						"type": "select",
						"class": "long1",
						"sel_action": "data_alluser",
						"sel_name": "",
						"sel_val": {},
						"sel": "2"
					}],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "申请人"
						},
						{
							"name": "费用类型"
						},
						{
							"name": "申请金额"
						},
						{
							"name": "申请备注"
						},
						{
							"name": "审核金额"
						},
						{
							"name": "审核备注"
						},
						{
							"name": "标识"
						},
						{
							"name": "开票"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [
					],
					"d_name": [
					]
				
				});

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}




		}
	};
</script>
<style>
</style>